export default "__VITE_ASSET__DXnm9hdy__"